// utils/qrUtils.js
export const generateQRData = (label) => {
  const code = label.label_item_id.id;
  const price = label.price;
  const conditionId = label.condition_id?.id || "";
  const boxCondition = label.box_condition ? 1 : 0;
  const priceSp = label.price_sp ? 1 : 0;
  const addId = label.add_id?.id || "";
  const setNumber = label.set_number || "";
  const setPlusId = label.set_plus_id || "";

  if (!setPlusId) {
    if (!addId) {
      return `${code},${price},${conditionId},${boxCondition},${priceSp}`;
    } else {
      return `${code},${price},${conditionId},${boxCondition},${priceSp},,${addId}`;
    }
  } else {
    if (!addId) {
      return `${code},${price},${conditionId},${boxCondition},${priceSp},${setNumber},,${setPlusId}`;
    } else {
      return `${code},${price},${conditionId},${boxCondition},${priceSp},${setNumber},${addId},${setPlusId}`;
    }
  }
};
